import { queryOptions } from '@tanstack/react-query';

import { API_ENDPOINT } from '~/config';
import { Partner } from '~/types/interfaces';

export type Lead = {
  partner: Partner;
  prospect: {
    name: string;
  };
};

export const getLead = (leadId: string) =>
  queryOptions({
    queryKey: ['getLead', leadId],
    queryFn: async (): Promise<Lead> => {
      const response = await fetch(`${API_ENDPOINT}/lead/${leadId}`);

      if (!response.ok) {
        throw new Error(`Error fetching lead data: ${response.statusText}`);
      }

      const lead = (await response.json()) as Lead;

      return lead;
    },
  });
